import { gridFilteredSortedRowEntriesSelector } from "@mui/x-data-grid";

// Every row the grid is currently showing, across all pages -- the filter and
// sort are applied, pagination is not. Use this rather than the component's own
// filtered array when an export should follow the grid's quick filter too.
//
// Note the near-miss: gridPaginatedVisibleSortedGridRowEntriesSelector returns
// the CURRENT PAGE only, which would silently export one page's worth.
export const getFilteredGridRows = (apiRef) =>
  gridFilteredSortedRowEntriesSelector(apiRef).map((entry) => entry.model);
